import { useTranslationInterface } from 'utils/hooks/useTranslation';
import { I18N_NAMESPACE } from '../constants';

// strings for this module are in src/services/i18n/en-us/segmentation.json

export const useTranslation = () => useTranslationInterface(I18N_NAMESPACE);
